import React, { useEffect } from 'react';
import { useAdminDashboardContext } from '../../../common/hooks/adminDashboardHook';
import Circle from '../../../common/components/Circle';
import SettingsForm from '@/pages/admin/dashboard/components/settings/SettingsForm';
import {
	CircleWrapper,
	SpaceBetween,
	Wrapper,
} from './dashboard.styles';
import { findDashboardView } from './helpers/findDashboardView';
import Icon from '@/common/components/Icon';
import { Colors } from '@/common/colors/colors';

const Dashboard = () => {
	const {
		loadData,
		dashboardSettings,
		setShowDashboardSettings,
		showDashboardSettings,
	} = useAdminDashboardContext();

	useEffect(() => {
		loadData();
	}, []);

	return (
		<>
			<SpaceBetween>
				<Wrapper>
					{dashboardSettings?.visible_views.map(({ name }, i) =>
						findDashboardView(name) ? (
							<div key={i}>{findDashboardView(name)[name]}</div>
						) : null,
					)}
					<Icon
						onClick={() => setShowDashboardSettings(true)}
						className='animation-scale'
						name='gear'
						style={{
							cursor: 'pointer',
							color: Colors.darkBlue,
							fontSize: '36px',
							position: 'absolute',
							bottom: '40px',
							right: '40px',
						}}
					/>
				</Wrapper>
				{dashboardSettings && (
					<CircleWrapper>
						<Circle
							refreshTime={dashboardSettings?.refresh_time_seconds}
							getData={loadData}
						/>
					</CircleWrapper>
				)}
			</SpaceBetween>
			{showDashboardSettings && <SettingsForm />}
		</>
	);
};

export default Dashboard;
